import { getFormValues } from 'redux-form'
import { TABLA_VOLCADORAS_CON_CEREAL_ASIGNADO } from '../../../../../config/tables'
import { COLUMNS_VOLCADORAS_CON_CEREAL_ASIGNADO } from './constantesVolcadorasConCerealAsignado'
import { FORM_CEREAL_A_VOLCADORA } from '../../../../../config/forms'
import Volcadora from '../../../../../models/volcadora/volcadora'
import Silo from '../../../../../models/silo/silo'
import { toast } from 'react-toastify'

export function actualizarDatosParaMuiTable () {
  return dispatch => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_VOLCADORAS_CON_CEREAL_ASIGNADO
    })
    Volcadora.getVolcadorasConCerealAsignado().then(callback)
    function callback (data) {
      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          columns: COLUMNS_VOLCADORAS_CON_CEREAL_ASIGNADO,
          data: data,
          title: false,
          isLoading: false,
          fixed2Decimales: false,
          options: {
            size: 'small'
          },
          extraOptions: {
            print: false,
            pagination: false,
            filter: false,
            fixedSearch: false,
            search: false,
            download: false,
            filterValues: false,
            viewColumns: false,
            selectBarTop: false,
            sort: false
          }
        },
        id: TABLA_VOLCADORAS_CON_CEREAL_ASIGNADO
      })
    }
  }
}

export function actualizarSilosValidosVolcadora (silosValidosVolcadora) {
  return dispatch => {
    dispatch({
      type: 'SILOS_VALIDOS_VOLCADORA',
      data: silosValidosVolcadora
    })
  }
}

export function modificarVolcadoraCamiones (volcadora) {
  return async (dispatch, getState) => {
    const state = getState()
    const Values = getFormValues(FORM_CEREAL_A_VOLCADORA)(state)
    console.log('Volcadora', volcadora)
    const datosVolcadora = await Volcadora.getVolcadorasCamionesPorVolcadora(volcadora)
    if (datosVolcadora.length > 0) {
      const cereal = (datosVolcadora[0].claveCereal) ? datosVolcadora[0].claveCereal : 'UNDEF'
      // const silo = (datosVolcadora[0].claveSilo) ? datosVolcadora[0].claveSilo : 'NINGUNO'
      // if (Values.silo !== silo) {
      //   console.log(Values.silo)
      //   Volcadora.updateVolcadora(volcadora, Values.silo)
      //     .then(data => {
      //       if (!data.error) {
      //         dispatch(actualizarDatosParaMuiTable())
      //         toast.success('Silo modificado exitosamente.')
      //       } else {
      //         toast.error('Error al modificar el Silo.')
      //       }
      //     })
      // }
      if (Values.cereal !== cereal) {
        console.log(Values.cereal)
        Silo.updateSilo(Values.cereal, Values.silo)
          .then(data => {
            if (!data.error) {
              dispatch(actualizarDatosParaMuiTable())
              toast.success('Cereal modificado exitosamente.')
            } else {
              toast.error('Error al modificar el Cereal.')
            }
          })
      }
    }
  }
}
